// The API pages with LIMIT/OFFSET over an ORDER BY that can tie, so a later
// page can repeat a Want-Listing an earlier one already carried. Dropping
// those keeps the repeat from rendering as a second card.
export const appendWantAdPage = (prev, incoming) => {
  const existing = prev || [];
  const seen = new Set(existing.map((item) => item?.Want_ad_Id));
  return [
    ...existing,
    ...(incoming || []).filter((item) => !seen.has(item?.Want_ad_Id)),
  ];
};
